import React from "react";
import PlanPanel from "./PlanPanel";
import {
    SCHEDULE_FIELD_HEIGHT,
    SCHEDULE_FIELD_WIDTH
} from "../../constants/cssConstants";
import Years from "./Years";
import Units from "./Units";

class SchedulePanel extends React.Component {
    render() {
        return(
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: SCHEDULE_FIELD_HEIGHT,
                    width: SCHEDULE_FIELD_WIDTH
                }}
            >
                <Years plan={this.props.plan} isLoading={this.props.isLoading}/>
                <PlanPanel
                    plan={this.props.plan}
                    isLoading={this.props.isLoading}
                    addCourseToPlan={this.props.addCourseToPlan}
                    moveCourse={this.props.moveCourse}
                    removeCourseFromPlan={this.props.removeCourseFromPlan}
                    getUnits={this.props.getUnits}
                    setIsDragging={this.props.setIsDragging}
                />
                <Units getUnits={this.props.getUnits} isLoading={this.props.isLoading} plan={this.props.plan}/>
            </div>
        );
    }
}

export default SchedulePanel;